module.exports = __webpack_public_path__ + "fonts/Inter-500-greek-ext52.2d64d8a.woff2";